import {Dialog} from '@common/ui/overlays/dialog/dialog';
import {DialogHeader} from '@common/ui/overlays/dialog/dialog-header';
import {Trans} from '@common/i18n/trans';
import {DialogBody} from '@common/ui/overlays/dialog/dialog-body';
import {useDialogContext} from '@common/ui/overlays/dialog/dialog-context';
import {useForm} from 'react-hook-form';
import {Form} from '@common/ui/forms/form';
import {DialogFooter} from '@common/ui/overlays/dialog/dialog-footer';
import {Button} from '@common/ui/buttons/button';
// import { LoanProductPayload, useUpdateLoanProduct } from '@app_modules/requests/use-update-loan-product';
import { LoanProduct } from './loan-product';
import { CrupdateLoanProductFields } from './crupdate-loan-product-fields';
import { LoanProductPayload } from '@app_modules/requests/use-create-loan-product';
import { useUpdateLoanProduct } from '@app_modules/requests/use-update-loan-product';

interface Props {
  loanProduct: LoanProduct;
}
export function UpdateLoanProductDialog({loanProduct}: Props) {
  const {formId, close} = useDialogContext();
  const form = useForm<LoanProductPayload>({
    defaultValues: {
      name: loanProduct.name,
      active: loanProduct.active,
    },
  });
  const updateLoanProduct = useUpdateLoanProduct(loanProduct.id, form);
  return (
    <Dialog>
      <DialogHeader>
        <Trans message="Update Loan Product" />
      </DialogHeader>
      <DialogBody>
        <Form
          id={formId}
          form={form}
          onSubmit={value => {
            updateLoanProduct.mutate(value, {
              onSuccess: () => close(),
            });
          }}
        >
          <CrupdateLoanProductFields />
        </Form>
      </DialogBody>
      <DialogFooter>
        <Button onClick={() => close()}>
          <Trans message="Cancel" />
        </Button>
        <Button
          form={formId}
          type="submit"
          variant="flat"
          color="primary"
          disabled={updateLoanProduct.isPending}
        >
          <Trans message="Update" />
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
